"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgToGooglePlay = function SvgToGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 150 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6a6 6 0 0 1 6-6h138a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.32 15.33c.293-.02.53-.097.71-.23.187-.133.347-.387.48-.76s.247-.927.34-1.66l.41-3.35h4.08v5.93h.61v1.97h-.83V16h-4.97v1.23h-.83v-1.9Zm5.19-.07v-5.19H44l-.33 2.67c-.08.68-.207 1.223-.38 1.63-.173.4-.387.697-.64.89h3.86Zm4.577.86c-.48 0-.9-.113-1.26-.34a2.331 2.331 0 0 1-.84-.92 2.82 2.82 0 0 1-.29-1.28c0-.467.096-.893.29-1.28.2-.387.48-.69.84-.91.36-.227.78-.34 1.26-.34s.9.113 1.26.34c.36.22.636.523.83.91.2.387.3.813.3 1.28 0 .467-.1.893-.3 1.28a2.26 2.26 0 0 1-.83.92c-.36.227-.78.34-1.26.34Zm-1.61-2.54c0 .333.063.643.19.93.126.287.31.517.55.69.246.167.536.25.87.25.333 0 .62-.083.86-.25.24-.173.423-.403.55-.69.126-.287.19-.597.19-.93 0-.333-.064-.64-.19-.92a1.589 1.589 0 0 0-.55-.68 1.43 1.43 0 0 0-.86-.26c-.334 0-.624.087-.87.26-.24.167-.424.393-.55.68-.127.28-.19.587-.19.92Zm7.352 2.54c-.473 0-.893-.11-1.26-.33a2.33 2.33 0 0 1-.85-.91c-.2-.387-.3-.82-.3-1.3 0-.473.1-.903.3-1.29.207-.387.49-.69.85-.91.367-.22.787-.33 1.26-.33.414 0 .76.073 1.04.22.28.147.524.353.73.62l-.5.46a1.448 1.448 0 0 0-1.23-.63c-.506 0-.913.173-1.22.52-.3.347-.45.793-.45 1.34s.15.997.45 1.35c.307.347.714.52 1.22.52.507 0 .917-.21 1.23-.63l.5.46c-.206.267-.45.473-.73.62-.28.147-.626.22-1.04.22Zm2.301-4.29v-.66h3.56v.66h-1.41V16h-.75v-4.17h-1.4Zm4.394 5.38a1 1 0 0 0 .41.08.777.777 0 0 0 .43-.11c.113-.073.21-.207.29-.4l.32-.73-2.02-4.88h.81l1.61 3.96 1.6-3.96h.82l-2.42 5.81c-.14.34-.33.587-.57.74a1.573 1.573 0 0 1-.85.24c-.2 0-.383-.023-.55-.07l.12-.68Zm5.802-5.38V16h-.75v-4.83h4.02V16h-.75v-4.17h-2.52Zm5.518-.66v2.01h2.52v-2.01h.75V16h-.75v-2.16h-2.52V16h-.75v-4.83h.75Zm6.877 4.95c-.48 0-.9-.113-1.26-.34a2.331 2.331 0 0 1-.84-.92 2.822 2.822 0 0 1-.29-1.28c0-.467.097-.893.29-1.28.2-.387.48-.69.84-.91.36-.227.78-.34 1.26-.34s.9.113 1.26.34c.36.22.637.523.83.91.2.387.3.813.3 1.28 0 .467-.1.893-.3 1.28a2.26 2.26 0 0 1-.83.92c-.36.227-.78.34-1.26.34Zm-1.61-2.54c0 .333.064.643.19.93.127.287.31.517.55.69.247.167.537.25.87.25.334 0 .62-.083.86-.25.24-.173.424-.403.55-.69.127-.287.19-.597.19-.93 0-.333-.063-.64-.19-.92a1.588 1.588 0 0 0-.55-.68 1.43 1.43 0 0 0-.86-.26c-.333 0-.623.087-.87.26-.24.167-.423.393-.55.68-.126.28-.19.587-.19.92Zm10.461-2.41c.42 0 .75.113.99.34.247.227.37.527.37.9a1.133 1.133 0 0 1-.78 1.1c.247.06.453.203.62.43.173.227.26.477.26.75 0 .393-.127.71-.38.95-.247.24-.59.36-1.03.36h-2.71v-4.83h2.66Zm-.1 4.17c.24 0 .43-.067.57-.2.14-.133.21-.313.21-.54a.74.74 0 0 0-.21-.53c-.14-.147-.33-.22-.57-.22h-1.81v1.49h1.81Zm-.03-2.15c.227 0 .403-.06.53-.18a.663.663 0 0 0 .19-.49c0-.213-.063-.38-.19-.5-.127-.127-.303-.19-.53-.19h-1.78v1.36h1.78Z",
    fill: "#C2C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.495 10.561c-.338.406-.509.926-.477 1.454v22.97c-.032.528.139 1.048.477 1.454l.073.073 12.867-12.856v-.301L10.568 10.488l-.073.073Z",
    fill: "url(#toGooglePlay_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.692 27.945-4.257-4.289v-.301l4.257-4.3.094.053 5.099 2.897c1.453.82 1.453 2.17 0 3.001l-5.078 2.887-.115.052Z",
    fill: "url(#toGooglePlay_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.817 27.882 23.435 23.5l-12.94 12.94a1.693 1.693 0 0 0 2.16.062l15.172-8.62",
    fill: "url(#toGooglePlay_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.817 19.118-15.172-8.62a1.693 1.693 0 0 0-2.16.063l12.95 12.94 4.382-4.383Z",
    fill: "url(#toGooglePlay_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.165 27.997v2.14H54.3a4.482 4.482 0 0 1-1.189 2.7 5.255 5.255 0 0 1-3.96 1.569 5.707 5.707 0 1 1 0-11.414 5.47 5.47 0 0 1 3.889 1.534l1.51-1.51a7.479 7.479 0 0 0-5.386-2.224 7.86 7.86 0 1 0 0 15.706 7.134 7.134 0 0 0 5.48-2.2 7.133 7.133 0 0 0 1.856-5.017c.004-.45-.036-.9-.12-1.343l-7.216.06ZM62.35 26.44a5.053 5.053 0 1 0 5.065 5.053 4.982 4.982 0 0 0-5.076-5.053h.011Zm6.04 5.069a5.053 5.053 0 0 1 5.03-5.07 4.982 4.982 0 0 1 5.077 5.054 5.053 5.053 0 0 1-10.106.016Zm2.048 1.314a3.068 3.068 0 0 0 2.982 1.737 2.924 2.924 0 0 0 2.853-3.067 3.068 3.068 0 1 0-5.835 1.33Zm-11.077.009a3.068 3.068 0 0 0 2.99 1.728h-.012a2.924 2.924 0 0 0 2.853-3.067 3.068 3.068 0 1 0-5.831 1.339Zm39.348-6.392a4.755 4.755 0 0 1 4.328 3.222l.25.535-6.765 2.794a2.568 2.568 0 0 0 2.449 1.534 2.89 2.89 0 0 0 2.485-1.403l1.724 1.189a5.03 5.03 0 0 1-4.209 2.235 4.946 4.946 0 0 1-5.017-5.053 4.756 4.756 0 0 1 4.755-5.053Zm-2.568 4.91a2.77 2.77 0 0 1 2.64-2.949 1.961 1.961 0 0 1 1.878 1.07l-4.518 1.88Zm-3.27 4.899h-2.223V21.386h2.224V36.25Zm-5.861-8.68h-.083a3.567 3.567 0 0 0-2.664-1.189 5.065 5.065 0 0 0 0 10.119 3.448 3.448 0 0 0 2.664-1.19h.071v.726c0 1.938-1.034 2.972-2.699 2.972a2.794 2.794 0 0 1-2.544-1.795l-1.938.808a4.815 4.815 0 0 0 4.482 2.985c2.604 0 4.756-1.534 4.756-5.268v-9H87.01v.832Zm-2.548 6.991h.004-.012.008Zm2.003-.953a2.83 2.83 0 0 1-2.003.953 3.08 3.08 0 0 1 .004-6.135 2.854 2.854 0 0 1 2.698 3.068 2.83 2.83 0 0 1-.699 2.114Zm26.988-12.22h-5.315v14.862h2.223v-5.636h3.104a4.624 4.624 0 1 0 0-9.226h-.012Zm-3.104 7.133h3.104l.047.036a2.55 2.55 0 1 0 0-5.1h-3.151v5.064Zm16.813-2.14a4.162 4.162 0 0 0-3.96 2.271l1.974.82a2.104 2.104 0 0 1 2.021-1.093 2.143 2.143 0 0 1 2.378 1.914v.155a4.908 4.908 0 0 0-2.318-.571c-2.129 0-4.281 1.189-4.281 3.34a3.436 3.436 0 0 0 3.686 3.27 3.127 3.127 0 0 0 2.854-1.426h.071v1.189h2.14v-5.72c0-2.603-1.973-4.113-4.506-4.113l-.059-.036Zm-2.01 6.884c0 .892 1.011 1.26 1.736 1.26l.06.036a2.686 2.686 0 0 0 2.603-2.378 3.945 3.945 0 0 0-2.021-.499c-1.117 0-2.378.392-2.378 1.581Zm14.375-6.527-2.544 6.444h-.072l-2.639-6.444h-2.378l3.959 9.012-2.259 5.006h2.318L142 26.737h-2.473Zm-17.763 9.512h-2.224V21.386h2.224V36.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "toGooglePlay_svg__a",
    x1: 17.799,
    y1: -5.119,
    x2: -2.803,
    y2: 0.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "toGooglePlay_svg__b",
    x1: 34.785,
    y1: 12.908,
    x2: 9.665,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "toGooglePlay_svg__c",
    x1: 10.115,
    y1: 16.779,
    x2: -6.434,
    y2: 44.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "toGooglePlay_svg__d",
    x1: 0.391,
    y1: 6.985,
    x2: 7.778,
    y2: 19.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgToGooglePlay);
var _default = exports["default"] = Memo;